import MixpanelBrowser from 'mixpanel-browser';
import { getVersion } from 'releases';
import {
  Transport,
  MixpanelTransportConfig,
  TrackingPayload,
  IdentityPayload,
} from '../tracking.types';

export const createMixpanelTransport = (): Transport => {
  let _initialized = false;

  return {
    name: 'mixpanel',

    init(config: MixpanelTransportConfig): void {
      if (_initialized) return;

      MixpanelBrowser.init(config.token, {
        debug: config.debug ?? false,
        ignore_dnt: true,
        ...config.options,
      });

      MixpanelBrowser.register({
        platform: 'web',
        'WebPage Version': getVersion(),
      });

      _initialized = true;
    },

    track(eventName: string, properties: TrackingPayload): void {
      if (!_initialized) return;

      const { uid } = properties;
      if (uid) MixpanelBrowser.identify(`${uid}`);

      // Special handling for Login event - set user properties
      if (eventName === 'Log In') {
        const { uid: _uid, ...rest } = properties;
        MixpanelBrowser.people.set(rest);
      }

      MixpanelBrowser.track(eventName, properties);
    },

    identify(payload: IdentityPayload): void {
      if (!_initialized) return;

      MixpanelBrowser.identify(`${payload.userId}`);

      const { userId, email, firstName, lastName, ...rest } = payload;
      MixpanelBrowser.people.set({
        ...rest,
        email,
        firstName,
        lastName,
      });
    },
  };
};
